import * as types from "./../types";

const state = {
  availableMarketData: [],
  baseCurrenciesData: [],
  filteredMarketData: [],
  selectedBaseCurrency: null,
  toCurrency: {},
  defaultToCurrency: {}
};

const getters = {
  [types.market.getters.GET_AVAILABLE_MARKET_DATA]: state => {
    return state.availableMarketData;
  },
  [types.market.getters.GET_BASE_CURRENCIES_DATA]: state => {
    return state.baseCurrenciesData;
  },
  [types.market.getters.GET_FILTERED_MARKET_LIST]: state => {
    return state.filteredMarketData;
  },
  [types.market.getters.GET_SELECTED_BASE_CURRENCY]: state => {
    return state.selectedBaseCurrency;
  },
  [types.market.getters.GET_TO_CURRENCY]: state => {
    return state.toCurrency;
  },
  [types.market.getters.GET_DEFAULT_TO_CURRENCY]: state => {
    return state.defaultToCurrency;
  }
};
const mutations = {
  [types.market.mutations.MUTATE_AVAILABLE_MARKET_DATA]: (state, payload) => {
    state.availableMarketData = payload;
  },
  [types.market.mutations.MUTATE_BASE_CURRENCIES_DATA]: (state, payload) => {
    state.baseCurrenciesData = payload;
  },
  [types.market.mutations.MUTATE_FILTERED_MARKET_LIST]: (state, payload) => {
    state.filteredMarketData = payload;
  },
  [types.market.mutations.MUTATE_SELECTED_BASE_CURRENCY]: (state, payload) => {
    state.selectedBaseCurrency = payload;
  },
  [types.market.mutations.MUTATE_TO_CURRENCY]: (state, payload) => {
    state.toCurrency = payload;
  },
  [types.market.mutations.MUTATE_DEFAULT_TO_CURRENCY]: (state, payload) => {
    state.defaultToCurrency = payload;
  }
};

const actions = {
  [types.market.actions.SET_AVAILABLE_MARKET_DATA]: ({ commit }, payload) => {
    commit(types.market.mutations.MUTATE_AVAILABLE_MARKET_DATA, payload);
  },
  [types.market.actions.SET_BASE_CURRENCIES_DATA]: ({ commit }, payload) => {
    commit(types.market.mutations.MUTATE_BASE_CURRENCIES_DATA, payload);
  },
  [types.market.actions.SET_FILTERED_MARKET_LIST]: ({ commit }, payload) => {
    commit(types.market.mutations.MUTATE_FILTERED_MARKET_LIST, payload);
  },
  [types.market.actions.SET_SELECTED_BASE_CURRENCY]: ({ commit }, payload) => {
    commit(types.market.mutations.MUTATE_SELECTED_BASE_CURRENCY, payload);
  },
  [types.market.actions.SET_TO_CURRENCY]: ({ commit }, payload) => {
    commit(types.market.mutations.MUTATE_TO_CURRENCY, payload);
  },
  [types.market.actions.SET_DEFAULT_TO_CURRENCY]: ({ commit }, payload) => {
    commit(types.market.mutations.MUTATE_DEFAULT_TO_CURRENCY, payload);
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
